import api from '@/api/index.js'

const emv_cut_over = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_EMV_CUT_OVER_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_EMV_CUT_OVER: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EMV_CUT_OVER_ERROR: (state, error) => {
      state.error = error
    },
    SET_EMV_CUT_OVER_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadEmvCutOver({commit}, query) {
      commit('SET_EMV_CUT_OVER', null)
      commit('SET_EMV_CUT_OVER_ERROR', null)
      commit('SET_EMV_CUT_OVER_LOADING', true)
      return api.get(`emv-cut-overs/${query.id}`)
        .then((response) => {
          commit('SET_EMV_CUT_OVER', response)
        })
        .catch((error) => {
          commit('SET_EMV_CUT_OVER_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_CUT_OVER_LOADING', false)
        })
    }
  }
}

export default emv_cut_over
